<!-- Off-canvas Modal -->
<div
  class="offcanvas offcanvas-end border-start border-top border-bottom"
  tabindex="-1"
  id="offcanvasRight"
  aria-labelledby="offcanvasRightLabel"
  data-bs-backdrop="static"
>
  <!-- Header -->
  <div class="offcanvas-header border-bottom">
    <div class="reprint-mode d-flex justify-content-end align-items-center">
      <h5 class="mb-0 me-2">
        {{
          container.id === 0 ? "Create Production Bin" : "Update Production Bin"
        }}
      </h5>
    </div>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
      (click)="resetForm()"
    ></button>
  </div>

  <!-- Body -->
  <form
    *ngIf="containerForm"
    [formGroup]="containerForm"
    class="d-flex flex-column h-100"
  >
    <div class="offcanvas-body flex-grow-1 overflow-auto">
      <!-- Reference No -->
      <div class="mb-3" *ngIf="container.id > 0">
        <label for="Referenceno" class="form-label required"
          >Reference No <span class="text-danger">*</span></label
        >
        <input
          type="text"
          id="Referenceno"
          class="form-control"
          formControlName="Referenceno"
          [(ngModel)]="container.referenceNumber"
          [disabled]="container.id > 0"
        />
      </div>

      <!-- Description -->
      <div class="mb-3">
        <label for="description" class="form-label required"
          >Bin Description <span class="text-danger">*</span></label
        >
        <textarea
          id="description"
          class="form-control mt-2"
          [(ngModel)]="container.description"
          placeholder="Enter Description"
          maxlength="50"
          formControlName="description"
          [class.is-invalid]="
            containerForm.get('description')?.invalid &&
            containerForm.get('description')?.touched
          "
        ></textarea>
      </div>

      <!-- Store -->
      <div class="mb-3">
        <label for="storeId" class="form-label required"
          >Select Store <span class="text-danger">*</span></label
        >
        <select
          id="storeId"
          class="form-select mt-2"
          formControlName="StoreId"
          [(ngModel)]="container.storeId"
          [class.is-invalid]="
            containerForm.get('StoreId')?.invalid &&
            containerForm.get('StoreId')?.touched
          "
        >
          <option [ngValue]="null" disabled selected>Select Store</option>
          <option *ngFor="let store of stores" [ngValue]="store.storeId">
            {{ store.storeName }}
          </option>
        </select>
        <div
          class="invalid-feedback"
          *ngIf="
            containerForm.get('StoreId')?.invalid &&
            containerForm.get('StoreId')?.touched
          "
        >
          Store is required.
        </div>
      </div>
      <div>
        <label for="ExternalId" class="form-label required"
          >Bin ID <span class="text-danger">*</span></label
        >
        <input
          type="text"
          id="ExternalId"
          class="form-control"
          formControlName="ExternalId"
          [(ngModel)]="container.externalId"
          placeholder="Enter Bin ID"
          maxlength="20"
          [class.is-invalid]="
            containerForm.get('ExternalId')?.invalid &&
            containerForm.get('ExternalId')?.touched
          "
        />
        <div
          class="invalid-feedback"
          *ngIf="
            containerForm.get('ExternalId')?.invalid &&
            containerForm.get('ExternalId')?.touched
          "
        >
          <ng-container *ngIf="containerForm.get('ExternalId')?.errors?.['required']">
            Bin ID is required.
          </ng-container>
          <ng-container *ngIf="containerForm.get('ExternalId')?.errors?.['maxlength']">
            Bin ID must be 20 characters or fewer.
          </ng-container>
        </div>
      </div>

      <!-- <div class="mb-3" *ngIf="container.id === 0">
        <label class="form-label d-block required mb-2"
          ><input
            type="checkbox"
            class="form-check-input p-1 mx-2"
            formControlName="isLabelPrint"
            name="isLabelPrint"
            id="isLabelPrint"
            (change)="onPrintClick()"
          />
          Print label after creation
        </label>
      </div> -->
    </div>

    <!-- Action Buttons -->
    <div
      class="offcanvas-footer border-top p-3 d-flex justify-content-end mt-auto"
    >
      <button
        type="button"
        class="btn modal-btn me-2"
        (click)="resetForm()"
        data-bs-dismiss="offcanvas"
      >
        Cancel
      </button>

      <button
        type="button"
        class="btn btn modal-btn add-btn"
        data-bs-dismiss="offcanvas"
        [disabled]="containerForm.invalid"
        (click)="addEditContainer(container)"
      >
        {{ container.id === 0 ? "Create Bin" : "Update Bin" }}
      </button>
    </div>
  </form>
</div>
